import { useCallback, useMemo } from 'react';
import Checkbox from 'unsubscribe-ui/components/core/inputs/Checkbox';
import HR from 'unsubscribe-ui/components/core/HR';
import Flex from 'unsubscribe-ui/components/core/layout/Flex';
import Spacer from 'unsubscribe-ui/components/core/layout/Spacer';
import Headings from 'unsubscribe-ui/components/core/typography/Heading';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
function SubscriptionRow({
  subscriptionDefinition: {
    id,
    process,
    name,
    operation,
    description
  },
  subscriptionStates,
  onSubscriptionChange
}) {
  const title = useMemo(() => process && operation ? `${process} ${operation} | ${name}` : name, [process, operation, name]);
  const onChange = useCallback(() => onSubscriptionChange(id), [onSubscriptionChange, id]);
  return /*#__PURE__*/_jsxs("span", {
    "data-test-id": `subscription-toggle-${id}-span`,
    children: [/*#__PURE__*/_jsx(Checkbox, {
      "data-test-id": `subscription-toggle-${id}`,
      onChange: onChange,
      checked: subscriptionStates[id],
      label: /*#__PURE__*/_jsxs(Flex, {
        "data-test-id": `subscription-toggle-${id}-label`,
        direction: "column",
        align: "left",
        textAlign: "left",
        children: [/*#__PURE__*/_jsx(Headings, {
          variant: "heading-100",
          children: title
        }), /*#__PURE__*/_jsx(Spacer, {
          marginBlock: "25"
        }), description]
      })
    }), /*#__PURE__*/_jsx(HR, {})]
  });
}
export default function SubscriptionList({
  subscriptionDefinitions,
  subscriptionStates,
  onSubscriptionChange
}) {
  return /*#__PURE__*/_jsx(_Fragment, {
    children: subscriptionDefinitions.map((subscriptionDefinition, index) => /*#__PURE__*/_jsx(SubscriptionRow, {
      subscriptionDefinition: subscriptionDefinition,
      onSubscriptionChange: onSubscriptionChange,
      subscriptionStates: subscriptionStates
    }, `sub-row-${index}`))
  });
}